
export const HelpProjectEquipmentEPCContract = () => {
    return (
        <div className="palantir-helpnote">
            <p>Each equipment group can be associated with an existing EPC Contract.</p>
            <p>This is particularly useful when there are multiple EPC Contracts, as each contract may apply to different equipment groups.</p>
        </div>
    )
}

export const HelpInverterEquipmentITCRate = () => {
    return (
        <div className="palantir-helpnote">
            <p>The ITC rate at the time which the equipment was <a href="https://en.wikipedia.org/wiki/Safe_harbor_(law)" target="_blank">Safe Harbored.</a></p>
        </div>
    )
}

export const HelpContractOwnerProvidedEquipment = () => {
    return (
        <div className="palantir-helpnote">
            <p>Whether the contract provides for <i>any type</i> of owner provided equipment.</p>
            <p>If the contract only specifies certain types of owner provided equipment (eg. Inverters and Modules), you may specify this in the corresponding Project Equipment Group.</p>
        </div>
    )
}

export const HelpDryBulbTemp = () => {
    return (
        <div className="palantir-helpnote">
            Used to derive <a href="http://ashrae-meteo.info/v2.0/" target="__blank">http://ashrae-meteo.info/v2.0/</a>
        </div>
    )
}
export const HelpRainfall = () => {
    return (
        <div className="palantir-helpnote">
            <p>Verify max 100yr 24hrs and annual rainfall at site.</p>
            <a href="https://hdsc.nws.noaa.gov/hdsc/pfds/pfds_map_cont.html" target="__blank">https://hdsc.nws.noaa.gov/hdsc/pfds</a>
        </div>
    )
}
export const HelpSnowLoad = () => {
    return (
        <div className="palantir-helpnote">
            <p>Determine Ground Snow Load per ASCE 7‐10</p>
            <a href="http://windspeed.atcouncil.org" target="__blank">http://windspeed.atcouncil.org</a>
        </div>
    )
}
export const HelpWindLoad = () => {
    return (
        <div className="palantir-helpnote">
            <p>Basic Wind Speed per ASCE 7‐10, Sec 26.5.1 and IBC 2012, Sec 1609.3</p>
            <p><a href="http://windspeed.atcouncil.org" target="__blank">http://windspeed.atcouncil.org</a></p>
            <p><a href="https://asce7hazardtool.online/" target="__blank">https://asce7hazardtool.online</a></p>
        </div>
    )
}
export const HelpSeismic = () => {
    return (
        <div className="palantir-helpnote">
            <p>Determine Risk Category per ASCE 7-10, Table 1.5-1 and IBC 2012, Sec/Table  1604.5. GM facilities are risk/occupancy category I, RM facilities category II., </p>
            <a href="https://seismicmaps.org/" target="__blank">https://seismicmaps.org/</a>
        </div>
    )
}
export const HelpFlood = () => {
    return (
        <div className="palantir-helpnote">
            <p>The Federal Emergency Management Agency (FEMA) groups Flood Zones</p>
            <a href="http://msc.fema.gov/portal" target="__blank">http://msc.fema.gov/portal</a>
        </div>
    )
}
export const HelpWetlands = () => {
    return (
        <div className="palantir-helpnote">
            <p>
                The Clean Water Act (CWA) per EPA & US Army Corp of Engineers classifies wetlands as “Waters of the US” to include swamps, marshes, bogs, etc.
                Refer to site map with delineated wetlands in Phase 1 ESA, or US Fish and Wildlife, National Wetlands Inventory.
            </p>
            <a href="https://www.fws.gov/program/national-wetlands-inventory/wetlands-mapper" target="__blank">https://www.fws.gov/program/national-wetlands-inventory/wetlands-mapper</a>
        </div>
    )
}
export const HelpBiological = () => {
    return (
        <div className="palantir-helpnote">
            <p>
                The Governmental Authority may require a Biological Permit/Study if threatened or endangered species (e.g. bog turtles) are known to inhabit the site area.
                Identify risk of on-site seasonal nesting by migratory birds.
                Refer to USFW Search <a href="https://www.fws.gov/program/endangered-species/species" target="__blank">https://www.fws.gov/program/endangered-species/species</a>
            </p>
        </div>
    )
}

export const HelpProjectCOD = () => {
    return (
        <div className="palantir-helpnote sm">
            <p className="header-2">Actual COD</p>
            <p>The actual date when the project achieved commerical operations. This date should remain blank until the project has closed financing.</p>
            <p className="header-2">Memo Approved COD</p>
            <p>The approved date per the most recent investment memo by which the project will achieve commerical operations (also known as Investment Case COD). This date should remain blank until the project has graduated to late-stage and has an approved stand-alone investment memo.</p>
            <p className="header-2">Target COD</p>
            <p>The target date by which the project will achieve commerical operations per the current project schedule. For stand-alone BESS projects, this date should reflect the Initial Delivery Date (IDD), if applicable.</p>
            <p className="header-2">P50 COD</p>
            <p>The base case estimated date by which the project will achieve commerical operations. This date should remain blank until the project has visibility on construction/completion costs and schedule.</p>
            <p className="header-2">P90 COD</p>
            <p>The conservative case estimated date by which the project will achieve commerical operations. This date should remain blank until the project has visibility on construction/completion costs and schedule.</p>
            <p className="header-2">Guaranteed COD</p>
            <p>The contractual date per the executed offtake agreement by which the project will achieve commerical operations. This date should remain blank until the project has entered into an offtake agreement and graduated to late-stage.</p>
            <p>This is located in the Offtake Contract.</p>
        </div>
    )
}
export const HelpProjectFinancialClose = () => {
    return (
        <div className="palantir-helpnote sm">
            <p className="header-2">Actual FC</p>
            <p>The actual date when project financing was secured. This date should remain blank until the project has closed financing.</p>
            <p className="header-2">Memo Approved FC</p>
            <p>The approved date per the most recent investment memo by which by which project financing will be secured. This date should remain blank until the project has graduated to late-stage and has an approved stand-alone investment memo.</p>
            <p className="header-2">Target FC</p>
            <p></p>
            <p className="header-2">P50 FC</p>
            <p>The base case estimated date by which project financing will be committed. This date should remain blank until the project has visibility on offtake, construction costs, permitting/site control and construction schedule.</p>
            <p className="header-2">P90 FC</p>
            <p>The conservative case estimated date by which project financing will be committed. This date should remain blank until the project has visibility on offtake, construction costs, permitting/site control and construction schedule.</p>
        </div>
    )
}

export const HelpProjectFNTP = () => {
    return (
        <div className="palantir-helpnote sm">
            <p className="header-2">Actual FNTP</p>
            <p>The actual date when the full notice to proceed was provided under the EPC agreement. This date should remain blank until FNTP is provided to the Contractor.</p>
            <p className="header-2">Contractual (Budgeted) FNTP</p>
            <p>The contractual date in the executed EPC agreement by which Owner must give Contractor the full notice to start construction activities. This date should remain blank until the EPC agreement is executed.</p>
            <p className="header-2">Target (Current) FNTP</p>
            <p>The target date by which the Contractor must start construction activities per the current project schedule (taking into consideration any LNTPs planned).</p>
        </div>
    )
}

export const HelpProjectTermConversion = () => {
    return (
        <div className="palantir-helpnote sm">
            <p className="header-2">Actual Term Conversion</p>
            <p>The actual date when the construction loan was closed out and replaced by permanent financing. This date should remain blank until term conversion has been achieved.</p>
            <p className="header-2">P50 Term Conversion</p>
            <p>The base case estimated date by which (1) any bridge loans are repaid, (2) if applicable, any project liens are released, and (3) construction financing is converted to mini-perm financing. This date should remain blank until the project has visibility on construction/completion costs and schedule and deal team has reviewed funding deliverables.</p>
            <p className="header-2">P90 Term Conversion</p>
            <p>The conservative case estimated date by which (1) any bridge loans are repaid, (2) if applicable, any project liens are released, and (3) construction financing is converted to mini-perm financing. This date should remain blank until the project has visibility on construction/completion costs and schedule and deal team has reviewed funding deliverables.</p>
        </div>
    )
}

export const HelpProjectFID = () => {
    return (
        <div className="palantir-helpnote sm">
            <p className="header-2">Actual Financial Investment Date</p>
            <p>The actual date when all key development risks were fully resolved and the project was considered Development Complete. This date should remain blank until FID is achieved.</p>
            <p className="header-2">Target Financial Investment Date</p>
            <p>The target date by which all key development risks are fully resolved and the project is consider Development Complete (target min 3 months prior to FC).</p>
        </div>
    )
}

export const HelpProjectStatus = () => {
    return (
        <div className="palantir-helpnote">
            <p>Current status of the Project.</p>
            <p className="header-2">Options</p>
            <strong style={{fontSize: 12}}>Due Diligence</strong>
            <p style={{fontSize: 10}}>Projects under review that are not in Development, Construction, or Operations</p>
            <strong style={{fontSize: 12}}>M&A</strong>
            <p style={{fontSize: 10}}>Placeholder for M&A annual MW targets (for planning purposes only)</p>
            <strong style={{fontSize: 12}}>Greenfield</strong>
            <p style={{fontSize: 10}}>Placeholder for M&A annual MW targets (for planning purposes only)</p>
            <strong style={{fontSize: 12}}>Development</strong>
            <p style={{fontSize: 10}}>Projects in development regardless of stage</p>
            <strong style={{fontSize: 12}}>Construction</strong>
            <p style={{fontSize: 10}}>Projects that have reached NTP and are in construction</p>
            <strong style={{fontSize: 12}}>Operating</strong>
            <p style={{fontSize: 10}}>Projects that have reached COD and are in operations</p>
            <strong style={{fontSize: 12}}>Sold - Proposed</strong>
            <p style={{fontSize: 10}}>Projects proposed for sale in the current year</p>
            <strong style={{fontSize: 12}}>Sold</strong>
            <p style={{fontSize: 10}}>Projects that have been sold</p>
            <strong style={{fontSize: 12}}>Write Off - Proposed</strong>
            <p style={{fontSize: 10}}>Projects proposed for write off in the current year</p>
            <strong style={{fontSize: 12}}>Write Off</strong>
            <p style={{fontSize: 10}}>Projects that have been written off</p>
        </div>
    )
}

export const HelpRiskRegisterBudgetedCostImpact = () => {
    return (
        <div className="palantir-helpnote">
            <p>Estimated or budgeted total cost impact of the risk or opportunity.</p>
            <p className="header-2">Formula</p>
            <p style={{fontSize: 12}}>budgeted_cost_impact = worst_case_cost_impact * (probability / 5)</p>
            <p className="header-2">Cost Impact Rating Thresholds</p>
            <div style={{display: "grid", marginTop: "10px"}}>
                <div style={{gridColumn: 1, gridRow: 1, fontSize: "11px", borderBottom: "solid 1px grey"}}>Budgeted Cost Impact Range</div>
                <div style={{gridColumn: 2, gridRow: 1, fontSize: "11px", borderBottom: "solid 1px grey"}}>Cost Impact Rating</div>
                <div style={{gridColumn: 1, gridRow: 2, fontSize: "11px"}}>$0 - $100,000</div>
                <div style={{gridColumn: 2, gridRow: 2, fontSize: "11px"}}>0</div>
                <div style={{gridColumn: 1, gridRow: 3, fontSize: "11px"}}>$100,000 - $500,000</div>
                <div style={{gridColumn: 2, gridRow: 3, fontSize: "11px"}}>1</div>
                <div style={{gridColumn: 1, gridRow: 4, fontSize: "11px"}}>$500,000 - $1,000,000</div>
                <div style={{gridColumn: 2, gridRow: 4, fontSize: "11px"}}>2</div>
                <div style={{gridColumn: 1, gridRow: 5, fontSize: "11px"}}>$1,000,000 - $2,000,000</div>
                <div style={{gridColumn: 2, gridRow: 5, fontSize: "11px"}}>3</div>
                <div style={{gridColumn: 1, gridRow: 6, fontSize: "11px"}}>$2,000,000 - $5,000,000</div>
                <div style={{gridColumn: 2, gridRow: 6, fontSize: "11px"}}>4</div>
                <div style={{gridColumn: 1, gridRow: 7, fontSize: "11px"}}>$5,000,000+</div>
                <div style={{gridColumn: 2, gridRow: 7, fontSize: "11px"}}>5</div>
            </div>
        </div>
    )
}

export const HelpLessonLearnedStatus = () => {
    return (
        <div className="palantir-helpnote">
            <p className="header-2">Submitted</p>
            <p>The responsible team (based on the assigned 'Origin Stage') has not read and reviewed the lesson.</p>
            <p className="header-2">Acknowledged</p>
            <p>The responseible team has reviewed and informed all necessary parties of the Lesson Learned.</p>
        </div>
    )
}